import { render, staticRenderFns } from "./ScreenAlcance.vue?vue&type=template&id=f800ec9e&scoped=true"
import script from "./ScreenAlcance.vue?vue&type=script&lang=js"
export * from "./ScreenAlcance.vue?vue&type=script&lang=js"
import style0 from "./ScreenAlcance.vue?vue&type=style&index=0&id=f800ec9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f800ec9e",
  null
  
)

export default component.exports